"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _AppContainer = _interopRequireDefault(require("./containers/AppContainer"));

var _DirectoryContainer = _interopRequireDefault(require("./containers/DirectoryContainer"));

var _GoodDetailsContainer = _interopRequireDefault(require("./containers/GoodDetailsContainer"));

var _GoodDetailsPreviewContainer = _interopRequireDefault(require("./containers/GoodDetailsPreviewContainer"));

var _GoodDetailsReviewContainer = _interopRequireDefault(require("./containers/GoodDetailsReviewContainer"));

var _ProviderSignupContainer = _interopRequireDefault(require("./containers/ProviderSignupContainer"));

var UrlPathParams = _interopRequireWildcard(require("./constants/UrlPathParams"));

var _managePurchasesPrefetcher = require("./prefetchers/managePurchasesPrefetcher");

var AsyncManagePurchases = (0, _Loadable.default)({
  loader: _managePurchasesPrefetcher.managePurchasesPrefetcher,
  LoadingComponent: function LoadingComponent(_ref) {
    var pastDelay = _ref.pastDelay;
    return pastDelay ? _react.default.createElement(_UILoadingSpinner.default, null) : null;
  },
  ErrorComponent: function ErrorComponent() {
    return _react.default.createElement(_UIErrorMessage.default, null);
  }
});

function _default() {
  return _react.default.createElement(_reactRouter.Route, {
    path: "/",
    component: _AppContainer.default
  }, _react.default.createElement(_reactRouter.IndexRedirect, {
    to: UrlPathParams.DIRECTORY_PAGE_PATH
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.DIRECTORY_PAGE_PATH,
    component: _DirectoryContainer.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.GOOD_DETAILS_PREVIEW_PATH,
    component: _GoodDetailsPreviewContainer.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.GOOD_DETAILS_REVIEW_PATH,
    component: _GoodDetailsReviewContainer.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.GOOD_DETAILS_PATH,
    component: _GoodDetailsContainer.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.MANAGE_PURCHASES_PATH,
    component: AsyncManagePurchases
  }), _react.default.createElement(_reactRouter.Route, {
    path: UrlPathParams.PROVIDER_SIGNUP_PATH,
    component: _ProviderSignupContainer.default
  }), _react.default.createElement(_reactRouter.Redirect, {
    from: UrlPathParams.GOOD_DETAILS_DEMO_PATH,
    to: UrlPathParams.GOOD_DETAILS_PATH
  }), _react.default.createElement(_reactRouter.Redirect, {
    from: "*",
    to: UrlPathParams.DIRECTORY_PAGE_PATH
  }));
}

module.exports = exports.default;